import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { API_URL } from '../config/api';
import { REGION_LABELS, REGION_ORDER } from '../constants/regions';

const SharePage = () => {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (shareId) {
      axios.get(`${API_URL}/v1/share/${shareId}`)
        .then(res => setData(res.data))
        .catch(err => {
          console.error('Share not found', err);
          setData(null);
        })
        .finally(() => setLoading(false));
    }
  }, [shareId]);

  if (loading) {
    return (
      <>
        <Header />
        <main className="main"><div className="loading"><p>Loading story...</p></div></main>
      </>
    );
  }

  if (!data) {
    return (
      <>
        <Header />
        <main className="main page-content">
          <div className="empty-state">
            <h2>Story not found</h2>
            <p>This shared story may have expired or doesn't exist.</p>
            <button className="action-btn" onClick={() => navigate('/')}>Browse All Stories</button>
          </div>
        </main>
      </>
    );
  }

  const { share, story, share_texts } = data;

  return (
    <>
      <Header />
      <main className="main page-content">
        <div className="share-header">
          <div className="share-label">Global News Comparison</div>
          <h1 className="share-title">{share.title}</h1>
          <div className="share-meta">{share.source_count} sources across {share.region_count} regions</div>
          <div className="share-insight">{share.framing_insight}</div>
        </div>
        
        {story && (
          <div className="comparison-grid share-grid">
            {REGION_ORDER.map(region => {
              const sources = story.sources_by_region?.[region] || [];
              return (
                <div key={region} className="region-col">
                  <div className="region-header">
                    <span>{REGION_LABELS[region]}</span>
                    <span className="count">{sources.length || '—'}</span>
                  </div>
                  <div className="region-body">
                    {sources.length > 0 ? sources.slice(0, 3).map((s, i) => (
                      <div key={i} className="source-item">
                        <div className="source-name">{s.source_name}</div>
                        <div className="source-headline">{s.title}</div>
                      </div>
                    )) : (
                      <div className="no-coverage">No coverage</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        
        <div className="share-actions">
          <h3>Share this comparison</h3>
          <div className="share-buttons">
            <a href={share_texts?.whatsapp_url} target="_blank" rel="noopener noreferrer" className="share-btn whatsapp">WhatsApp</a>
            <a href={share_texts?.twitter_url} target="_blank" rel="noopener noreferrer" className="share-btn twitter">Twitter</a>
            <a href={share_texts?.linkedin_url} target="_blank" rel="noopener noreferrer" className="share-btn linkedin">LinkedIn</a>
            <button className="share-btn" onClick={() => navigator.clipboard.writeText(share_texts?.url)}>Copy Link</button>
          </div>
        </div>
        
        <div className="share-cta">
          <h2>Explore more stories</h2>
          <p>See how global media frames today's biggest stories differently.</p>
          <button className="action-btn primary" onClick={() => navigate('/')}>Open Framecast News</button>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SharePage;
